import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminClientDetail from "@/pages/AdminClientDetail";
import AdminSettings from "@/pages/AdminSettings";
import AdminContracts from "@/pages/AdminContracts";
import SignContract from "@/pages/SignContract";
import BookingSuccess from "@/pages/BookingSuccess";

import "@/App.css";

function ProtectedAdmin({ children }) {
  const { user, isAdmin, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (!isAdmin) return <Navigate to="/admin/login" replace state={{ error: "Not authorized" }} />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Process Emergent OAuth callback before any other route.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/booking-success" element={<BookingSuccess />} />
      <Route path="/sign/:token" element={<SignContract />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
      <Route path="/admin/contracts" element={<ProtectedAdmin><AdminContracts /></ProtectedAdmin>} />
      <Route path="/admin/settings" element={<ProtectedAdmin><AdminSettings /></ProtectedAdmin>} />
      <Route path="/admin/clients/:id" element={<ProtectedAdmin><AdminClientDetail /></ProtectedAdmin>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
